import styled from "styled-components";
import { Icon, ButtonSettings } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const IconStyled = styled(Icon)`
  width: ${props => props.iconWidth || props.theme.components.selector.icon.size};
  height: ${props => props.iconHeight || props.theme.components.selector.icon.size};
  fill: ${props => props.theme.color.white};
`;

export const PageWrapper = styled.div`
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 6.579rem; 
  padding-top: 4.211rem;
`;

export const LogoStyled = styled.div`
  position: absolute;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}:4.6rem`};
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 50rem;
  width: 81rem;
`;

export const MainHeading = styled.h3`
  color: ${props => props.theme.color.white};
  font-size: ${props => props.theme.font.size.large};
  font-weight: ${props => props.theme.font.weight.semiBold};
  margin-bottom: ${props => props.theme.spacing.xsmall};
  line-height: ${props => props.theme.font.lineHeight.medium};
`;

export const HeadingText = styled.p`
  color: ${props => props.theme.color.greyLight};
  font-size: ${props => props.theme.font.size.small};
`;

export const HeadingWrapper = styled.div``;

export const MainViewWrapper = styled.div``;

export const MainViewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ListItemWrapper = styled.ul`
  text-align: ${props => (props.theme.locale.dir === "rtl" ? "right" : "left")};
  width: 50rem;
`;

export const ProfileImageWrapper = styled.div`
  text-align: center;
`;

export const ProfileImageContainer = styled.div`
  height: 20rem;
  width: 20rem;
  border-radius: 50%;
`;
export const ProfileImage = styled.img`
  height: 100%;
  width: 100%;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.24);
  border-radius: 50%;
`;

export const ProfileName = styled.div`
  color: ${props => props.theme.color.greyLight};
  font-size: ${props => props.theme.font.size.medium};
  font-weight: ${props => props.theme.font.weight.semiBold};
  line-height: ${props => props.theme.font.lineHeight.small};
  margin-top: ${props => props.theme.spacing.xxsmall};
`;

export const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.2rem;
  p {
    color: ${props => props.theme.color.white};
    font-size: ${props => props.theme.font.size.xsmall};
    line-height: 1.125rem;
  }
`;

export const InstructionText = styled.p`
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}:${props =>
  props.theme.spacing.xsmall}; 
`;

export const ButtonsWrapper = styled.div`
  ${props =>
    props.direction === "rtl" &&
    `margin-left:30rem;
          direction:ltr;
         `};
`;

export const ButtonStyled = styled(ButtonSettings)`
  width: 23.5rem;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.3);
  background-color: ${props => props.theme.color.secondary};
  margin: 0 ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? props.theme.spacing.small : 0)} 0
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? props.theme.spacing.small : 0)};
  box-sizing: border-box;
  height: 66px;
  ${props => props.disabled && `opacity: 0.6`};
`;
